import { createAction, createActionGroup, props } from "@ngrx/store";

export const getUserProfile = createActionGroup({
    source: 'Shared',
    events: {
        'Load User Profile': props<{ status: 'request' | 'success' | 'failure', data?: any, error?: any }>(),                     // triggers effect
    }
});
export const getCountryCulture = createActionGroup({
    source: 'culture',
    events: {
        'Load Country Culture': props<{ status: 'request' | 'success' | 'failure', data?: any, error?: any }>(),                     // triggers effect
    }
});

export const addRouteToHistory = createAction(
    '[Router] Add Route To History', props<{ url: string }>()
);

export const updateUserName = createAction(
  '[Shared] Update User Name',
  props<{ firstName: string; lastName: string }>()
);
export const resetAppStateAction = createAction('[App] Reset App State');